export function initCollapseTextMedia() {
  const textmediaContainers = document.querySelectorAll('.js-textmedia');
  const collapseClass = 'textmedia__text--collapsed';
  const activeButton = 'textmedia__button--active';

  textmediaContainers.forEach((container) => {
    const collapseButton = container.querySelector('.js-collapseButton');
    const bodyText = container.querySelector('.js-textMediaBodytext');

    if (collapseButton && bodyText) {
      collapseButton.addEventListener('click', () => {
        bodyText.classList.toggle(collapseClass);
        collapseButton.classList.toggle(activeButton);
      });
    }
  });
}
